module.exports = __webpack_public_path__ + "static/media/_MG_5s058-1-7.eb6b9320.jpg";